import ServerSideRender from '@wordpress/server-side-render';
import { useBlockProps } from '@wordpress/block-editor';
import metadata from './block.json';

export function edit() {
	return (<div {...useBlockProps()}>
		<ServerSideRender block={metadata.name} />
	</div>)
}